interface MfaNoteProps {
  children: string;
  hidden?: boolean;
}

export function MfaNote({ children, hidden = false }: MfaNoteProps) {
  return (
    <div className={`mfa-note ${hidden ? 'hidden' : ''}`.trim()}>
      <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <circle cx="7" cy="7" r="6" />
        <path d="M7 4v3.5M7 10h.01" strokeLinecap="round" />
      </svg>
      {children}
    </div>
  );
}
